import { RouteItem } from '@eastcoal/router/types/route'

import { PRICE_COMPARE_PURCHASE_LIST_PAGE_PATH } from './constants/path'

export const priceComparePurchaseListRoute: RouteItem = {
  title: '比价采购',
  path: PRICE_COMPARE_PURCHASE_LIST_PAGE_PATH,
  Component: () => import('./index')
}
